import cn from '../../utils/cn';
import { initials } from '../../utils/format';

/** Deterministic tint so the same person always reads the same colour. */
const TINTS = [
  ['#e6edfb', '#1b4db1'],
  ['#eae2f8', '#6b34ab'],
  ['#e0f2ea', '#0f7b4f'],
  ['#fceee2', '#b2571b'],
  ['#fde9e8', '#b0302a'],
  ['#e2f4f2', '#0b7f73'],
  ['#f3eddc', '#8a6d2f'],
  ['#e9eaee', '#4a5361'],
];

function tintFor(name = '') {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return TINTS[hash % TINTS.length];
}

export default function Avatar({ name, src, size = 'md', className, title }) {
  const [bg, fg] = tintFor(name || '');
  return (
    <span
      className={cn('avatar', size !== 'md' && `avatar--${size}`, className)}
      style={src ? undefined : { background: bg, color: fg }}
      title={title || name}
      aria-hidden={title ? undefined : 'true'}
    >
      {src ? <img src={src} alt="" /> : initials(name)}
    </span>
  );
}

export function UserCell({ user, size = 'sm', showEmail }) {
  if (!user) return <span className="muted">—</span>;
  return (
    <span className="user-cell">
      <Avatar name={user.name} size={size} />
      <span className="stack truncate" style={{ gap: 0 }}>
        <span className="truncate">{user.name}</span>
        {showEmail && <span className="meta truncate">{user.email}</span>}
      </span>
    </span>
  );
}
